<template>
  <b-card no-body class="document mt-4" @click="downloadDocument()">
    <b-card-body class="d-flex align-items-center">
      <font-awesome-icon
        :icon="'file-' + document.documentFormat.toLowerCase()"
        class="file-icon mr-3"
      />
      <h4 class="document-name mb-0">
        {{ document.documentName }}
        <span class="document-type">{{ document.documentType }}</span>
      </h4>
      <font-awesome-icon icon="cloud-download-alt" class="download-icon" v-if="!downloading"/>
      <font-awesome-icon icon="spinner" class="download-icon" spin v-if="downloading"/>
    </b-card-body>
  </b-card>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";
</style>

<script>
import { getDocumentUrl } from "@/services/api";
import { EventBus } from "@/services/event-bus.js";

export default {
  name: "DocumentCard",
  components: {},
  props: {
    format: String,
    document: Object,
    jobId: String
  },
  data() {
    return {
      docName: this.document.documentName,
      downloading: false
    };
  },
  methods: {
    async downloadDocument() {
      this.downloading = true;
      EventBus.$emit("showLoader");
      const link = document.createElement("a");

      try {
        const url = await getDocumentUrl(this.jobId, this.docName);
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      } catch (result) {
        EventBus.$emit("triggerAlert", {
          type: "danger",
          message: "An unknown error occurred"
        });
      }
      EventBus.$emit("hideLoader");
      this.downloading = false;
      document.body.removeChild(link);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DocumentCard.vue